/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Street View Icon component.
 */
export const SystemStreetViewIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z' fill={iconColor} />
      <path d='M12 18H14V13H16V9C16 7.897 15.103 7 14 7H10C8.897 7 8 7.897 8 9V13H10V18H12Z' fill={iconColor} />
      <path d='M18.446 11.3857L17.553 13.1747C19.108 13.9497 20 14.9797 20 15.9997C20 17.8917 16.715 19.9997 12 19.9997C7.285 19.9997 4 17.8917 4 15.9997C4 14.9797 4.892 13.9497 6.446 13.1747L5.553 11.3857C3.295 12.5117 2 14.1927 2 15.9997C2 19.3637 6.393 21.9997 12 21.9997C17.607 21.9997 22 19.3637 22 15.9997C22 14.1927 20.705 12.5117 18.446 11.3857Z' fill={iconColor} />
    </svg>
  );
};

export default SystemStreetViewIcon;
